import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QtySelectAbstract } from '../ui/form/qty-select.abstract';

@Component({
    selector: 'item-qty',
    templateUrl: './item-qty.html',
    standalone: true,
    imports: [CommonModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemQtyComponent extends QtySelectAbstract {
    @Input()
    itemId: number;
}
